"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moreList = void 0;
const toggle_1 = require("./toggle");
/**
 * もっと見るボタン
 */
/**
 * 開くキーフレーム
 */
const animateOpenKeyframes = (content) => [
    {
        height: 0,
    },
    {
        height: `${content.children[0].clientHeight}px`,
    },
];
const moreList = () => {
    var _a;
    const list = document.getElementById("js-moreList");
    const button = document.getElementById("js-moreList__button");
    const outerHeight = list === null || list === void 0 ? void 0 : list.clientHeight;
    const innerHeight = (_a = list === null || list === void 0 ? void 0 : list.querySelector("ul")) === null || _a === void 0 ? void 0 : _a.clientHeight;
    if (outerHeight !== undefined && innerHeight !== undefined && outerHeight >= innerHeight) {
        button === null || button === void 0 ? void 0 : button.setAttribute("aria-hidden", "true");
    }
    button === null || button === void 0 ? void 0 : button.addEventListener("click", () => {
        button === null || button === void 0 ? void 0 : button.setAttribute("aria-hidden", "true");
        list === null || list === void 0 ? void 0 : list.classList.add("is-opened");
        list === null || list === void 0 ? void 0 : list.animate(animateOpenKeyframes(list), toggle_1.animateOptions);
    });
};
exports.moreList = moreList;
